import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DivisionItem } from "@/services/entities/DivisionItem";
import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxPaging,
    DxStateStoring,
    DxHeaderFilter, DxPager,
    DxButton,
} from "devextreme-vue/data-grid";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DivisionTable',
  props: {
    data: { Type: [] as DivisionItem[], default: [] as DivisionItem[] },
},
  emits: ["edit", "delete"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selectedKeys = ref([] as number[]);

const props = __props;

function edit(item: any) {
    selectedKeys.value = [item.row.data.id];
    emit("edit", item.row.data.id);
}

function deleteRate(item: any) {
    emit("delete", item.row.data.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    id: "gridContainer",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "ID",
        visible: false
      }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "storage"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "name",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "Edit rate",
            icon: "edit",
            "styling-mode": "contained",
            type: "normal",
            onClick: edit
          }),
          _createVNode(_unref(DxButton), {
            hint: "Delete rate",
            icon: "trash",
            "styling-mode": "contained",
            type: "normal",
            onClick: deleteRate
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 12 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})